"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canCreateCAPEventAccount = exports.getORGIDsFromRegularCAPAccount = exports.getORGIDsFromCAPAccount = exports.getEmbedLink = exports.renderAccountID = exports.getORGIDFromAccount = exports.isRegularCAPAccountObject = void 0;
const types_1 = require("../typings/types");
const Maybe_1 = require("./Maybe");
const Member_1 = require("./Member");
const isRegularCAPAccountObject = (account) => account.type === types_1.AccountType.CAPGROUP ||
    account.type === types_1.AccountType.CAPREGION ||
    account.type === types_1.AccountType.CAPSQUADRON ||
    account.type === types_1.AccountType.CAPWING;
exports.isRegularCAPAccountObject = isRegularCAPAccountObject;
const getORGIDFromAccount = (account) => account.type === types_1.AccountType.CAPSQUADRON ? account.mainOrg : account.orgid;
exports.getORGIDFromAccount = getORGIDFromAccount;
const renderAccountID = (account) => `${account.id.replace(/([a-zA-Z]{3})([a-zA-Z]{2})([0-9]*)/, '$1-$2-$3').toUpperCase()}`;
exports.renderAccountID = renderAccountID;
const getEmbedLink = (account) => `<iframe src=\"https://calendar.google.com/calendar/embed?src=${encodeURIComponent(account.mainCalendarID)}&ctz=America%2FNew_York\" style=\"border: 0\" width=\"720\" height=\"540\" frameborder=\"0\" scrolling=\"no\"></iframe>`;
exports.getEmbedLink = getEmbedLink;
const getORGIDsFromCAPAccount = (account) => account.type === types_1.AccountType.CAPSQUADRON
    ? Maybe_1.Maybe.some([account.mainOrg, ...account.orgIDs])
    : account.type === types_1.AccountType.CAPGROUP || account.type === types_1.AccountType.CAPREGION
        ? Maybe_1.Maybe.some([account.orgid])
        : account.type === types_1.AccountType.CAPWING
            ? Maybe_1.Maybe.some([account.orgid, ...account.orgIDs])
            : Maybe_1.Maybe.none();
exports.getORGIDsFromCAPAccount = getORGIDsFromCAPAccount;
const getORGIDsFromRegularCAPAccount = (account) => account.type === types_1.AccountType.CAPWING
    ? [account.orgid, ...account.orgIDs]
    : account.type === types_1.AccountType.CAPSQUADRON
        ? [account.mainOrg, ...account.orgIDs]
        : [account.orgid];
exports.getORGIDsFromRegularCAPAccount = getORGIDsFromRegularCAPAccount;
const canCreateCAPEventAccount = (parent) => (user) => {
    const duties = user.dutyPositions
        .filter(duty => duty.type === 'CAPUnit' ||
        Maybe_1.Maybe.orSome([])(exports.getORGIDsFromCAPAccount(parent)).includes(duty.orgid))
        .map(({ duty }) => duty);
    return (Member_1.isRioux(user) ||
        ((parent.type === types_1.AccountType.CAPWING || parent.type === types_1.AccountType.CAPREGION) &&
            Member_1.isCAPMember(user) &&
            (duties.includes('Commander') ||
                duties.includes('Information Technologies Officer') ||
                Member_1.hasPermission('CreateEventAccount')(types_1.Permissions.CreateEventAccount.YES)(user))));
};
exports.canCreateCAPEventAccount = canCreateCAPEventAccount;
//# sourceMappingURL=Account.js.map